import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "gfu-dcc-wrapper",
  "data-qa": "dcc-wrapper"
}
const _hoisted_2 = { class: "gfu-hd gfu-hd--h3 _mt-5" }
const _hoisted_3 = { class: "_mt-2" }
const _hoisted_4 = { "format-key": "0" }
const _hoisted_5 = { "format-key": "1" }
const _hoisted_6 = { "format-key": "2" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dcc_option = _resolveComponent("dcc-option")
  const _component_option_field = _resolveComponent("option-field")
  const _component_localize = _resolveComponent("localize")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.Resources.Checkout.CheckoutTransactionCurrencyHeader), 1 /* TEXT */),
    ($options.isProjectCurrencyVisible)
      ? (_openBlock(), _createBlock(_component_dcc_option, {
          key: 0,
          modelValue: $options.selectedOption,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = $event => (($options.selectedOption) = $event)),
            _cache[1] || (_cache[1] = $event => ($options.onOptionChange(_ctx.dccType.projectCurrency)))
          ],
          "label-text": _ctx.Resources.Checkout.CheckoutProjectCurrencyLabel,
          "checkbox-group-name": "dynamicCurrencyConversion",
          "checked-value": _ctx.dccType.projectCurrency
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($options.projectCurrencyAmount), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "label-text", "checked-value"]))
      : _createCommentVNode("v-if", true),
    ($options.isDynamicCurrencyVisible)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_dcc_option, {
            modelValue: $options.selectedOption,
            "onUpdate:modelValue": [
              _cache[3] || (_cache[3] = $event => (($options.selectedOption) = $event)),
              _cache[4] || (_cache[4] = $event => ($options.onOptionChange(_ctx.dccType.systemSuggestion)))
            ],
            "label-text": _ctx.Resources.Checkout.CheckoutPlatformSuggestionCurrencyLabel,
            "checkbox-group-name": "dynamicCurrencyConversion",
            "checked-value": _ctx.dccType.systemSuggestion
          }, {
            default: _withCtx(() => [
              ($options.isForceDynamicConversionCurrency)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString($options.suggestedCurrencyAmount), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createBlock(_component_option_field, {
                    key: 1,
                    modelValue: $options.suggestedCurrency,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($options.suggestedCurrency) = $event)),
                    inline: true,
                    options: $options.availableCurrenciesOptions,
                    small: true,
                    "display-name": _ctx.Resources.Checkout.CheckoutConvertedCurrencySelectLabel,
                    "label-class": "_sr-only",
                    onChange: $options.onDropdownOptionChange,
                    "data-qa": "suggested-currency-select"
                  }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "onChange"]))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue", "label-text", "checked-value"]),
          _createElementVNode("div", _hoisted_3, [
            ($options.isDccSystemSuggestionSelected)
              ? (_openBlock(), _createBlock(_component_localize, {
                  key: $options.currencyConversionInfoDetail,
                  resource: _ctx.Resources.Checkout.CheckoutDccMoreInfoParagraph
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.originalCurrencyOrderAmount) + " " + _toDisplayString($options.cartDetails.currencyShortName), 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_5, _toDisplayString($options.dropdownSelectedCurrencyShortName), 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_6, _toDisplayString($options.currencyConversionInfoDetail), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["resource"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString($options.currencyConversionInfoDetail), 1 /* TEXT */)),
            _cache[5] || (_cache[5] = _createTextVNode()),
            _createElementVNode("a", {
              class: "gfu-link gfu-link--accent",
              target: "_blank",
              href: $options.articleUrl,
              rel: "noopener noreferrer nofollow"
            }, _toDisplayString(_ctx.Resources.Common.MoreInfoHeader), 9 /* TEXT, PROPS */, _hoisted_8)
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}